import { render, staticRenderFns } from "./SSOSignInView.vue?vue&type=template&id=a3058f52&scoped=true"
import script from "./SSOSignInView.vue?vue&type=script&lang=ts"
export * from "./SSOSignInView.vue?vue&type=script&lang=ts"
import style0 from "./SSOSignInView.vue?vue&type=style&index=0&id=a3058f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3058f52",
  null
  
)

export default component.exports